import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getDeals } from 'app/state/ducks/deals/selectors';
import { SelectWithTable } from 'app/views/components/inputs/selects/CustomSelectWithTable';
import { TradeEntryDealTable } from './trade-entry-deal-table';

type Props = {
  onChange: (value?: string | null) => void;
  value: string;
  loading: boolean;
};

export function TradeEntryDealSearch({ onChange, value, loading }: Props) {

  const deals = useSelector(getDeals);

  // Filter and sort approved deals
  const approvedDeals = deals.filter((deal) => deal.status === 'Approved').sort((a, b) => a.dealName.localeCompare(b.dealName));

  const [dropdownOpen, setDropdownOpen] = useState(false); // State to control dropdown visibility
  const [searchValue, setSearchValue] = useState(value ?? ''); // State to control the search filter
  const [filteredDeals, setFilteredDeals] = useState(approvedDeals); // State to store the filtered deals

  useEffect(() => {
    setFilteredDeals(approvedDeals.filter((d) =>
      d.dealName.toLowerCase().includes(searchValue.toLowerCase()) ||
      d.cusip?.toLowerCase().includes(searchValue.toLowerCase()) ||
      d.lxId?.toLowerCase().includes(searchValue.toLowerCase()) ||
      d.id.toLowerCase().includes(searchValue.toLowerCase())
    ))
  }, [searchValue, deals]);

  useEffect(() => {
    // if (filteredDeals.length === 1) {
    //   handleSelectChange(filteredDeals[0].dealName);
    // }
    if (filteredDeals.length > 1 && dropdownOpen) {
      onChange(null);
    }
  }, [filteredDeals, dropdownOpen]);

  useEffect(() => {
    if (!value) {
      setSearchValue('');
    }
    const selectedDeal = filteredDeals.find((e) => e.id === value);
    setSearchValue(selectedDeal?.dealName ?? ''); // Set search value to the selected entity name
  }, [value])


  const handleSelectChange = (value: string) => {
    onChange(value); // Notify parent component of the selection
    setDropdownOpen(false); // Close dropdown after selection
  };


  return (
    <SelectWithTable
      disabled={loading}
      searchValue={searchValue}
      open={dropdownOpen}
      setOpen={setDropdownOpen}
      setSearchValue={setSearchValue}
    >
      <TradeEntryDealTable data={filteredDeals} handleSelectChange={handleSelectChange} searchValue={searchValue} />
    </SelectWithTable>
  );
}
